import { fetchLanguageList } from "../../api/language";
/* eslint-disable no-console */
const app = {
  state: {
    langList: []
  },

  mutations: {
    SET_LANG: (state, lang) => {
      state.langList = lang
    }
  },

  actions: {
    // 用户名登录
    GetLangList({ commit }) {
      return new Promise((resolve, reject) => {
        fetchLanguageList({ sort: 'id DESC'}).then(response => {
          const data = response.data;
          commit('SET_LANG', data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
};

export default app
